import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useRouteKeyStore } from '@/store/routeKeyStore';
import type { ComponentType } from 'react';

export type AppRouteProps<T> = {
  component: ComponentType<T>;
  routeKey: string;
};

const AppRoute = <T extends Record<string, unknown>>({
  component: Component,
  routeKey,
  ...props
}: AppRouteProps<T>) => {
  const location = useLocation();
  const setCurrentRouteKey = useRouteKeyStore((state) => state.setCurrentRouteKey);

  useEffect(() => {
    setCurrentRouteKey(routeKey);
  }, [location, routeKey, setCurrentRouteKey]);

  return <Component {...(props as T)} />;
};

export default AppRoute;
